import classNames from "classnames/bind";
import styles from "./index.module.scss";
import nextIcon from "images/IPX/NewYork/ipx_frenzinnewyork_gui_icon_next_01.png";
const cn = classNames.bind(styles);

function View({npcName, currentText, onClickDialogue, isDialogueOpen}) {
  return (
    <>
      {isDialogueOpen && (
        <div className={cn("chat")} onClick={onClickDialogue}>
          <div className={cn("npc_name")}>{npcName}</div>
          <div className={cn("current_text")}>{currentText}</div>
          <img className={cn("next_icon")} src={nextIcon} alt="next-icon"></img>
        </div>
      )}
    </>
  );
}

export default View;
